var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_vm.patientData.isLoaded
        ? _c(_setup.PatientProfileModalSkeleton)
        : _c(
            "div",
            { staticClass: "text--text pa-4" },
            [
              _c("div", { staticClass: "text-subtitle-1 mb-6" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_setup.tStatic("Доверие к профилю")) +
                    "\n    "
                ),
              ]),
              _vm._v(" "),
              _c(_setup.PatientProfileTrustInfo, {
                staticClass: "mb-6",
                attrs: {
                  "trust-percent": _vm.patientData.trust_percent || 0,
                  "can-trust": Boolean(_vm.patientData.can_trust),
                },
              }),
              _vm._v(" "),
              _c(_setup.PatientProfileCriteria, {
                staticClass: "mb-10",
                attrs: { criteria: _vm.patientData.trust_criteria || [] },
              }),
              _vm._v(" "),
              _c(_setup.PatinetProfileRatesStatistic, {
                staticClass: "mb-10",
                attrs: {
                  "count-canceled": _vm.patientData.count_rates_canceled || 0,
                  "count-negative": _vm.patientData.count_rates_negative || 0,
                  "count-positive": _vm.patientData.count_rates_positive || 0,
                  "count-without-mark":
                    _vm.patientData.count_rates_without_mark || 0,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-space-between text-subtitle-1" },
                [
                  _c("span", { staticClass: "mr-4" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_setup.tStatic("Записи на приём через")) +
                        " "
                    ),
                    _c("br"),
                    _vm._v(" " + _vm._s(_setup.brandName) + "\n      "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      attrs: {
                        "data-qa": "patient_profile_count_appointments",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.patientData.count_appointments ||
                              _setup.tStatic("Нет")
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }